import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	add: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.add.add',
		defaultMessage: 'Add new time slot for {day}',
		description: 'Button to add new time range',
	},
});
